import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import StyledSkeleton from './skeleton.style.js';

const Skeleton = (_a) => {
    var { backgroundColor = 'secondary', borderRadius = 'small', className = '', height = '16px', margin = { top: '8px' }, maxWidth, maxHeight, opacity = 'high', padding = {}, width = '150px', withShimmer = true } = _a, rest = __rest(_a, ["backgroundColor", "borderRadius", "className", "height", "margin", "maxWidth", "maxHeight", "opacity", "padding", "width", "withShimmer"]);
    return (jsx(StyledSkeleton, Object.assign({ backgroundColor: backgroundColor, borderRadius: borderRadius, className: className, height: height, margin: margin, maxWidth: maxWidth, maxHeight: maxHeight, opacity: opacity, padding: padding, width: width, withShimmer: withShimmer }, rest), void 0));
};

export { Skeleton, Skeleton as default };
